import { defineComponent as _defineComponent } from 'vue'
import { debounce } from 'lodash'
import { onMounted, ref, watch, nextTick, computed } from 'vue'
import { useNotification } from '@kyvg/vue3-notification'
import useGlobal from '@composables/useGlobal'
import { prop } from 'ramda'


export default /*@__PURE__*/_defineComponent({
  __name: 'UiQuantity',
  props: {
  disabled: {
    type: Boolean,
    default: false, 
  },
  modelValue: {
    type: [String, Number],
    default: 1,
  },
  minCount: {
    type: Number,
    default: 1,
  },
  maxCount: {
    type: Number,
    default: 10000,
  },
  batchRemainder: {
    type: Number,
  },
  isLoad: {
    type: Boolean,
    default: false,
  },
  isFullQuantity: {
    type: Boolean,
    default: false,  
  },
  isDecimal: {
    type: Boolean,
    default: false,
  },
  divisibleCount: {
    type: [Number, String],
    default: 1,
  },
},
  emits: ['update:modelValue', 'fullQuantity'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit

const { notify } = useNotification()

const props = __props

const { $t } = useGlobal()

const debounceUpdate = ref(null)
const debounceEmitValue = ref(null)
const localCount = ref(1)

const currentMaxCount = computed(() => {
  return props.batchRemainder ? Number(props.batchRemainder) + props.maxCount : props.maxCount
})

const currentMinCount = computed(() => {
  return props.batchRemainder && props.maxCount < localCount.value ? Number(props.batchRemainder) : props.minCount
})

watch(() => props.modelValue, () => {
  const v = Number(props.modelValue)
  if (v > currentMaxCount.value) {
    localCount.value = currentMaxCount.value
  } else {
    localCount.value = v
  }
}, { immediate: true })

const counterDecrease = () => {
  if (props.isLoad) return

  /**
   * decrease value of counter
   */
  if (currentMinCount.value < localCount.value) {
    if (props.isDecimal) {
      localCount.value = Number((Number(localCount.value) - currentMinCount.value))
    } else {
      localCount.value--
    }

    debounceEmitValue.value()
  }
}

const counterIncrease = () => {
  if (props.isLoad) return

  /**
   * inrease value of counter
   */
  if (props.isDecimal) {
    localCount.value = Number((Number(localCount.value) + currentMinCount.value).toFixed(2))
  } else {
    localCount.value++
  }

  checkMaxCount()

  debounceEmitValue.value()
}

const blurEvent = () => {
  const zero = 0
  /**
   * reset counter if user don't write the value
   */
   const count = Number(localCount.value)

  if (count < currentMinCount.value || (!count && count !== zero)) {
    resetCounter()
    emitValue()
  }
}

const updateEvent = () => {
  const zero = 0
  /**
   * reset counter if user don't write the value
   */
   const count = Number(localCount.value)

  if (count < currentMinCount.value || (!count && count !== zero)) {
    resetCounter()
  } else if (localCount.value > zero) {
    checkMaxCount()
  }

  debounceEmitValue.value()
}

const checkMaxCount = () => {
  if (localCount.value >= currentMaxCount.value) {
    localCount.value = currentMaxCount.value
    notify({
      text: `${$t('Максимальное количество товара доступное к заказу -')} ${currentMaxCount.value}`,
      type: 'error',
    })
  }
}

const resetCounter = () => {
  localCount.value = currentMinCount.value
  notify({
    text: `${$t('Минимальное количество товара доступное к заказу -')} ${currentMinCount.value}`,
    type: 'error',
  })
}

const emitValue = async () => {
  /**
   * emit current value
   */
  await nextTick()

  const val = Number(localCount.value)
  const remainder = props.batchRemainder && props.isFullQuantity ? 0 : Number((val % currentMinCount.value).toFixed(2))
  const valIsDivisible = remainder === 0

  if (props.isDecimal) {
    if (valIsDivisible) {
      emit('update:modelValue', (val).toFixed(2))
    } else {
      // const updatedValue = val + (currentMinCount.value - remainder)
      const updatedValue = val
      localCount.value = updatedValue
      emit('update:modelValue', (updatedValue).toFixed(2))
    }
  } else {
    const integerValue = Math.round(Number(val))
    console.log("🚀 ~ emitValue ~ integerValue:", integerValue)
    localCount.value = integerValue
    emit('update:modelValue', integerValue)
  }
}

onMounted(() => {
  /**
   * add debounce wrapper for prevent multiple requests
  */
  debounceEmitValue.value = debounce(emitValue, 200)
  debounceUpdate.value = debounce(updateEvent, 1500)
})

const __returned__ = { emit, notify, props, $t, debounceUpdate, debounceEmitValue, localCount, currentMaxCount, currentMinCount, counterDecrease, counterIncrease, blurEvent, updateEvent, checkMaxCount, resetCounter, emitValue, get debounce() { return debounce }, onMounted, ref, watch, nextTick, computed, get useNotification() { return useNotification }, get useGlobal() { return useGlobal }, get prop() { return prop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})